import UIFetchService from '../Service/UIFetchService';

import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { Card, Tree, Row, Col, Layout, Input, message, notification, Select, Button, Space, Modal, Table } from 'antd';
import { DownOutlined, UserOutlined, HomeOutlined } from '@ant-design/icons';
import { Base64 } from 'js-base64';
import React, { useEffect, useState } from 'react';
import { isEmpty } from '../Service/Utils';

class ExportingView extends React.Component {
    constructor() {
        super();
        this.state = {
            schemes: {
                all: [],
                owns: []
            },
            teams: [],
            teamsTree: {
                expendedKeys: ['staff/*', 'intern/*'],
                selectedKeys: ['staff/*']
            },
            projects: { ODPS: [] },
            projectOptions: { ODPS: [] },
            fileName: '',
            selectedOrigin: "ODPS",
            selectedProjectName: 'bcz_datap',
            exportingJobsStatusVisible: false
        };
    }

    render() {
        return <Layout className="site-layout-background" style={{ padding: '24px 0' }} >
            <Layout.Sider theme="light" width="20%" style={{ margin: '10px' }}>
                <Row>
                    <Col flex="100%">
                        <Input.Search
                            size='small'
                            allowClear
                            //onSearch={this.teamsTreeDidSearch}
                            onChange={this.teamsTreeDidChanged.bind(this)}
                        />
                    </Col>
                </Row>
                <div style={{ height: 20 }}></div>
                <Row>
                    <Col flex="100%">
                        <Card>
                            <Tree
                                showIcon
                                switcherIcon={<DownOutlined />}
                                defaultExpandAll={true}
                                defaultExpandedKeys={this.state.teamsTree.expendedKeys}
                                defaultExpandParent
                                onSelect={this.teamsTreeDidSelected.bind(this)}
                                autoExpandParent={true}
                                selectedKeys={this.state.teamsTree.selectedKeys}
                                treeData={this.state.teams}
                            />
                        </Card>
                    </Col>
                </Row>
            </Layout.Sider>
            <Layout.Content style={{ padding: '10px 0px 0px 0px' }}>
                <Row>
                    <Col style={{ alignSelf: 'center' }}>
                        <span>需求方：</span>
                    </Col>
                    <Col>
                        <Input
                            size='small'
                            value={this.state.selectedStaffName}
                            readOnly
                            style={{width: 100}}
                        ></Input>
                    </Col>
                    <Col style={{ alignSelf: 'center', margin: '0 0 0 7px' }}>
                        <span>文件名：</span>
                    </Col>
                    <Col>
                        <Input
                            size='small'
                            value={this.state.fileName}
                            style={{width: 180}}
                            placeholder="不填使用默认文件名"
                            onChange={({target: {value}})=> {

                                this.setState({fileName: value});
                            }}
                        ></Input>
                    </Col>
                    <Col style={{ alignSelf: 'center', margin: '0 0 0 7px' }}>
                        <span>数据源：</span>
                    </Col>
                    <Col>
                        <Input
                            size='small'
                            value='MaxCompute'
                            readOnly
                            style={{width: 100}}
                        ></Input>
                    </Col>
                    <Col style={{ alignSelf: 'center', margin: '0 0 0 7px' }}>
                        <span>项目空间：</span>
                    </Col>
                    <Col>
                        <Select
                            size='small'
                            value={this.state.selectedProjectName}
                            onChange={value => this.setState({ selectedProjectName: value })}
                            style={{ width: 150 }}
                        >
                            {this.state.projectOptions.ODPS.map(
                                p => <Select.Option key={p} value={p}>{p}</Select.Option>)}
                        </Select>
                    </Col>
                    <Col flex='auto'></Col>
                    <Col>
                        <Space>
                            <Button
                                size='small'
                                onClick={this.showHistory.bind(this)}
                            >任务状态</Button>
                            <Button 
                                size='small'
                                type='primary'
                                disabled={this.state.selectedStaffId === undefined}
                                onClick={this.commit.bind(this)}
                            >提交任务</Button>
                        </Space>
                    </Col>
                </Row>
                <Row style={{ margin: '10px 0 0 0' }}>
                    <Col flex="100%">
                        <div id="site-exporting-script" style={{ textAlign: 'left' }}></div>
                    </Col>
                </Row>
                <ExportingJobsStatusView
                    visible={this.state.exportingJobsStatusVisible}
                    onOk={() => this.setState({ exportingJobsStatusVisible: false })}
                    onCancel={() => this.setState({ exportingJobsStatusVisible: false })}
                />
            </Layout.Content>
        </Layout>
    }

    async componentDidMount() {
        const teams = await UIFetchService.get('/api/v1/perm/teams');
        for (let team of teams) {
            this.setUpTeamIcons(team);
        }
        this.teamsTreeExpandAll(teams);
        this.setState({ teams: teams });
        this.fetchProjects();

        const domNode = document.getElementById('site-exporting-script');
        const instance = monaco.editor.create(domNode, {
            value: '',
            theme: 'vs-light',
            fontSize: 12,
            language: 'sql',
            automaticLayout: true,
            minimap: false,
        });
        this.editor = instance;
        window.onresize = this.onWindowSize;
        this.onWindowSize();
    }

    async commit() {
        const chs = "/\\,`~!@#$%^&*();:'";
        for (let i = 0; i < i < chs.length; i++) {
            if (isEmpty(chs.charAt(i))) {
                break;
            }
            if (this.state.fileName.indexOf(chs.charAt(i)) >= 0) {
                message.error('不能使用特殊字符：' + chs);
                return;
            }
        }

        const rs = await UIFetchService.post(`/api/v1/querying_exporting/jobs`, {
            proposerId: this.state.selectedStaffId,
            origin: "ODPS",
            projectName: this.state.selectedProjectName,
            fileName: this.state.fileName,
            committedSql: Base64.encode(this.editor.getValue())
        });
        if (rs) {
            //console.log(rs);
            notification.info({
                message: `数据生成中...任务ID：${rs.jobId}`,
                description: '请耐心等待；可能需要1～5分钟。'
            });
        } else {
            message.error('数据生成失败');
        }
    }

    showHistory() {
        this.setState({ exportingJobsStatusVisible: true });
    }

    componentWillUnmount() {
        this.editor.dispose();
        delete window.onresize;
    }

    onWindowSize = () => {
        if (this.editor === undefined) {
            return;
        }

        this.editor.layout({
            width: document.body.clientWidth - 520,
            height: document.body.clientHeight - 220
        });
    }

    fetchProjects() {
        UIFetchService.get('/api/v1/schema/projects')
            .then(projects => this.setState({
                projects: projects,
                projectOptions: projects,
                selectedOrigin: "ODPS",
                selectedProjectName: 'bcz_datap'
            }));
    }

    setUpTeamIcons(root) {
        if (root.leaf) {
            root.icon = <UserOutlined />
        } else {
            root.icon = <HomeOutlined />
        }
        if (root.children !== null && root.children !== undefined) {
            for (let child of root.children) {
                this.setUpTeamIcons(child)
            }
        }
    }

    teamsTreeExpandAll(teams) {
        const keys = [];

        const search = (root) => {
            //if (!root.leaf) {
            keys.push(root.key);
            //}
            if (root.children !== null && root.children !== undefined) {
                for (let child of root.children) {
                    search(child);
                }
            }
        };
        teams.forEach(search);
        //console.log(keys);
        const state = this.state.teamsTree;
        state.expendedKeys = keys;
        this.setState({ teamsTree: state });
    }

    teamsTreeDidExpand(keys) {
        const state = this.state.teamsTree;
        state.expendedKeys = keys;
        this.setState({ teamsTree: state });
    }

    async teamsTreeDidSelected(keys) {
        const state = this.state.teamsTree;
        state.selectedKeys = keys;
        this.setState({ teamsTree: state });
        const uid = this.hasStaffSelected(keys);
        if (uid > 0) {
            let selectedStaffName = '';
            const search = (node) => {
                if (node.key === uid.toString()) {
                    selectedStaffName = node.title;
                    return;
                }
                if (node.children) {
                    for (let child of node.children) {
                        search(child);
                    }
                }
            };
            for (let node of this.state.teams) {
                search(node);
            }

            this.setState({ selectedStaffId: uid, selectedStaffName });
        } else {
            this.setState({ selectedStaffId: undefined, selectedStaffName: undefined });
        }
    }

    async teamsTreeDidSearch(key) {
        const teams = await UIFetchService.get('/api/v1/perm/teams?searchKey=' + encodeURI(key));
        for (let team of teams) {
            this.setUpTeamIcons(team);
        }
        this.teamsTreeExpandAll(teams);
        this.setState({ teams: teams });
    }

    teamsTreeDidChanged(event) {
        this.teamsTreeDidSearch(event.target.value);
    }

    hasStaffSelected(keys) {
        if (keys.length <= 0) {
            return 0;
        }
        const key = keys[0];
        const uid = parseInt(key);
        return Number.isNaN(uid) ? 0 : uid;
    }
}

function ExportingJobsStatusView(props) {
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [jobs, setJobs] = useState([]);
    const [total, setTotal] = useState(0);

    async function getJobs(pageNo, pageSize) {
        const rs = await UIFetchService.get(`/api/v1/querying_exporting/jobs?pageNo=${pageNo}&pageSize=${pageSize}`);
        if (rs) {
            setJobs(rs.items);
            setTotal(rs.total);
        }
    }

    useEffect(async () => {
        await getJobs(pageNo, pageSize);
    }, []);

    return <Modal
        {...props}
        maskClosable={false}
        width={1400}
    >
        <Row style={{ padding: '30px 0 0 0' }}>
            <Col flex='100%'>
                <Table
                    dataSource={jobs}
                    size='small'
                    rowKey="jobId"
                    bordered
                    scroll={{
                        x: 1500
                    }}
                    footer={() => <Row justify='center'>
                        <Col>
                            <Button
                                size='small'
                                onClick={() => getJobs(pageNo, pageSize)}
                            >刷新</Button>
                        </Col>
                    </Row>}
                    pagination={{
                        current: pageNo,
                        pageSize,
                        total,
                        onChange: (pageNo, pageSize) => {
                            setPageNo(pageNo);
                            setPageSize(pageSize);
                            getJobs(pageNo, pageSize);
                        }
                    }}
                >
                    <Table.Column
                        title="ID"
                        dataIndex="jobId"
                        width={80}
                    />
                    <Table.Column
                        title="创建时间"
                        dataIndex="createdAt"
                        width={180}
                        render={createdAt => <span style={{ fontSize: 12 }}>{createdAt}</span>}
                    />
                    <Table.Column
                        title="文件名"
                        dataIndex="fileName"
                        width={180}
                    />
                    <Table.Column
                        title="状态"
                        dataIndex="status"
                        width={50}
                    />
                    <Table.Column
                        title="执行进度"
                        render={({ current, total }) => {
                            let percent = (current / total) * 100;
                            percent = Number.isNaN(percent) ? 'N/A' : percent.toFixed(2);
                            return <code style={{ fontSize: 12 }}>
                                {current}/{total} ({percent}%)
                            </code>
                        }}
                        width={200}
                    />
                    <Table.Column
                        title="需求方"
                        dataIndex="proposerName"
                        width={100}
                    />
                    <Table.Column
                        title="处理人"
                        dataIndex="processorName"
                        width={100}
                    />
                    <Table.Column
                        title="类型"
                        dataIndex="origin"
                    />
                    <Table.Column
                        title="项目空间"
                        dataIndex="projectName"
                    />
                    <Table.Column
                        title="SQL"
                        dataIndex="committedSql"
                        ellipsis="true"
                        width={400}
                    />
                </Table>
            </Col>
        </Row>
    </Modal>;
}

export default ExportingView;